<template>
    <div>
        <v-autocomplete
            :label="label"
            :items="list"
            v-model="input"
            item-value="id"
            item-text="name"
            :loading="loading"          
            :disabled="loading || disabled"
            :auto-select-first="true"
            :filled="filled"
            @change="changed($event)"
            clearable
            hide-details
            :multiple="multiple"
            :dense="dense"
            />
    </div>
</template>
<script>
import SelectorService from '@services/front/SelectorService';

export default {
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        }, 
        label: { 
            type: String, 
            default: 'Divisa' 
        },
        params: {
            type: Object,
        },
        filled: {
            type: Boolean,
            default: true,
        },
        multiple: {
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        divisa: {
            default: () => {
                return null;
            },
        },
    },
    data: function () {
        return {
            loading: false,
            list: [],
            input: this.multiple ? [] : null,
        }
    },
    computed: {
        isNumero: function () {
            return this.loading || !this.list.length;
        }
    },
    mounted: function () {
        this.get();
    },
    methods: {
        changed: function (value) {
            this.$emit('input', value);
            this.$emit('change', value);
            if (this.multiple) {
                this.$emit('update:divisa', this.list.filter(divisa => value.some(divisa_id => divisa_id == divisa.id)));
            } else {
                this.$emit('update:divisa', this.list.find(divisa => divisa.id == value));
            }
        },
        get: function () {
            this.loading = true;
            SelectorService
                .getDivisa(this.params)
                .then(({ divisaList = [] }) => {
                    this.list = divisaList;
                    if (divisaList.length == 1) {
                        this.input = this.multiple ? [divisaList[0].id] : divisaList[0].id;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        value: function (value) {
            this.input = value;
        },
        input: function (value) {
            this.changed(value);
        },
        params: {
            handler: function () {
                this.$lodash.throttle(() => {
                    this.get();
                }, 500);
            },
            deep: true,
        }
    }
}
</script>